import defaultValidatorRules from '@yiban-shared/config/validator-rules';

export default {
  ...defaultValidatorRules
};
